import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./adminModal.css";

// The one dialog implementation - replaces react-confirm-alert's unthemed
// default CSS everywhere it was used. Closes on Escape and backdrop click,
// and moves focus into the dialog when it opens (returns it to the
// trigger on close) for keyboard/screen-reader users.
export const AdminModal = ({ isOpen, onClose, title, children, footer, size = "md" }) => {
  const dialogRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    triggerRef.current = document.activeElement;
    dialogRef.current?.focus();

    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      if (triggerRef.current instanceof HTMLElement) triggerRef.current.focus();
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div className="admin-modal-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div
        className={`admin-modal admin-modal--${size}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        ref={dialogRef}
        tabIndex={-1}
      >
        {title && (
          <div className="admin-modal__header">
            <h2 className="admin-modal__title">{title}</h2>
            <button type="button" className="admin-modal__close" onClick={onClose} aria-label="Close dialog">
              &times;
            </button>
          </div>
        )}
        <div className="admin-modal__body">{children}</div>
        {footer && <div className="admin-modal__footer">{footer}</div>}
      </div>
    </div>,
    document.body
  );
};
